import { PersonDto } from "../../../client/person/PersonApiClient";

export default class PersonActionStatusChecker {

    static isFoundPersonRobUpdated(previousRecord: PersonDto | undefined, latestRecord: PersonDto): boolean {
        const prevDateValue = previousRecord?.robUpdatedAt;
        const latestDateValue = latestRecord.robUpdatedAt;

        const isLatestDateMissing = !latestDateValue;
        const isPreviousDateMissing = !prevDateValue;

        if (isLatestDateMissing) {
            return false;
        }

        if (isPreviousDateMissing) {
            return true;
        }

        const prevDate = new Date(prevDateValue);
        const latestDate = new Date(latestDateValue);

        if (isNaN(prevDate.getTime()) || isNaN(latestDate.getTime())) {
            return false;
        }

        return prevDate.getTime() < latestDate.getTime();
    }

    static canForceSyncRezaRepresentations(person: PersonDto): boolean {
        return !!person?.personAclDto?.canForceSyncRezaRepresentations;
    }

    static isFoundPersonCorrectlySubscribed(person: PersonDto): boolean {
        const { canSubscribeToUpdatesFromRob, canUnsubscribeToUpdatesFromRob } = person.personAclDto;
        return !canSubscribeToUpdatesFromRob && canUnsubscribeToUpdatesFromRob;
    }

    static isFoundPersonCorrectlyUnsubscribed(person: PersonDto): boolean {
        const { canSubscribeToUpdatesFromRob, canUnsubscribeToUpdatesFromRob } = person.personAclDto;
        return canSubscribeToUpdatesFromRob && !canUnsubscribeToUpdatesFromRob;
    }
}
